import { getStore, setStore, removeStore } from './store';

const adminToken = 'ADMIN-TOKEN';
const username = 'USER-NAME';
const rule = 'RULE';

// 获取token
export function getToken() {
  return getStore(adminToken);
}

// 设置token
export function setToken(sid) {
  return setStore(adminToken, sid);
}

// 删除token
export function removeToken() {
  return removeStore(adminToken);
}

// 获取username
export function getUsername() {
  return getStore(username);
}

// 设置username
export function setUsername(val) {
  return setStore(username, val);
}

// 删除username
export function removeUsername() {
  return removeStore(username);
}

// 获取rule
export function getRule() {
    return getStore(rule);
}

// 设置rule
export function setRule(val) {
    return setStore(rule, val);
}

// 删除rule
export function removeRule() {
    return removeStore(rule);
}
